'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function selectionExists() {
  var selection = window.getSelection();
  return selection && selection.rangeCount > 0 && selection.getRangeAt(0) && !selection.getRangeAt(0).collapsed && selection.getRangeAt(0).getBoundingClientRect().width > 0 && selection.getRangeAt(0).getBoundingClientRect().height > 0;
}

function clearSelection() {
  if (window.getSelection) {
    window.getSelection().removeAllRanges();
  } else if (document.selection) {
    document.selection.empty();
  }
}

var SelectionPopover = function (_Component) {
  _inherits(SelectionPopover, _Component);

  function SelectionPopover(props) {
    _classCallCheck(this, SelectionPopover);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SelectionPopover).call(this, props));

    _this._handleMouseUp = function () {
      if (selectionExists()) {
        _this.props.onSelect();
        return _this.computePopoverBox();
      }
      _this.props.onDeselect();
    };

    _this.computePopoverBox = function () {
      var selection = window.getSelection();
      if (!selectionExists()) {
        return;
      }
      var selectionBox = selection.getRangeAt(0).getBoundingClientRect();
      var popoverBox = _this.refs.selectionPopover.getBoundingClientRect();
      var targetBox = document.querySelector('[data-selectable]').getBoundingClientRect();
      _this.setState({
        popoverBox: {
          top: selectionBox.top - targetBox.top - _this.props.topOffset,
          left: selectionBox.width / 2 - popoverBox.width / 2 + (selectionBox.left - targetBox.left)
        }
      });
    };

    _this.handleClickOutside = function () {
      _this.props.onDeselect();
    };

    _this.state = {
      popoverBox: {
        top: 0,
        left: 0
      }
    };
    return _this;
  }

  _createClass(SelectionPopover, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.showPopover === true && nextProps.showPopover === false) {
        clearSelection();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var target = document.querySelector('[data-selectable]');
      target.addEventListener('mouseup', this._handleMouseUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var target = document.querySelector('[data-selectable]');
      target.removeEventListener('mouseup', this._handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var onDeselect = _props.onDeselect;
      var onSelect = _props.onSelect;
      var showPopover = _props.showPopover;
      var children = _props.children;
      var style = _props.style;
      var topOffset = _props.topOffset;

      var otherProps = _objectWithoutProperties(_props, ['onDeselect', 'onSelect', 'showPopover', 'children', 'style', 'topOffset']); // eslint-disable-line no-unused-vars


      var _state$popoverBox = this.state.popoverBox;
      var top = _state$popoverBox.top;
      var left = _state$popoverBox.left;


      var visibility = showPopover ? 'visible' : 'hidden';
      var display = showPopover ? 'inline-block' : 'none';

      return _react2.default.createElement(
        'div',
        _extends({
          ref: 'selectionPopover',
          style: _extends({
            visibility: visibility,
            display: display,
            position: 'absolute',
            top: top,
            left: left
          }, style)
        }, otherProps),
        children
      );
    }
  }]);

  return SelectionPopover;
}(_react.Component);

SelectionPopover.propTypes = {
  children: _react.PropTypes.node.isRequired,
  style: _react.PropTypes.object,
  topOffset: _react.PropTypes.number,
  onDeselect: _react.PropTypes.func.isRequired,
  onSelect: _react.PropTypes.func.isRequired,
  showPopover: _react.PropTypes.bool.isRequired
};

SelectionPopover.defaultProps = {
  topOffset: 30
};

exports.default = (0, _reactOnclickoutside2.default)(SelectionPopover);


//////////////////
// WEBPACK FOOTER
// ./~/react-selection-popover/dist-modules/index.js
// module id = 100
// module chunks = 0